export const basePlanInitialState = {
    hasSpd: undefined,
    name: undefined,
    externalId: undefined,
    moduleName: undefined,
    planType: undefined,
    carrierName: undefined,
};
//# sourceMappingURL=basePlan.js.map